import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { RichTextHtmlPipe } from '../../pipe/rich-text-html.pipe';
import { AccordionItemBasic } from './accordion-item.model';

@Component({
  selector: 'app-accordion',
  templateUrl: './accordion.component.html',
  styleUrls: ['./accordion.component.scss'],
  imports: [CommonModule, RichTextHtmlPipe]
})
export class AccordionComponent {
  @Input() items: AccordionItemBasic[] = [];
  activeIndex: number | null = null;

  toggle(index: number): void {
    this.activeIndex = this.activeIndex === index ? null : index;
  }
}
